import React, { createContext, useContext, useState } from 'react';
import { AccountTier, VaultRole, VaultStatus } from '../types/api';

interface VaultContextValue {
  activeVaultId: string | null;
  activeVaultName: string | null;
  activeVaultAccountTier: AccountTier | null;
  activeVaultStatus: VaultStatus | null;
  activeVaultUserRole: VaultRole | null;
  setActiveVault: (id: string | null, name: string | null, tier?: AccountTier | null, status?: VaultStatus | null, userRole?: VaultRole | null) => void;
}

const VaultContext = createContext<VaultContextValue>({
  activeVaultId: null,
  activeVaultName: null,
  activeVaultAccountTier: null,
  activeVaultStatus: null,
  activeVaultUserRole: null,
  setActiveVault: () => {},
});

export function VaultProvider({ children }: { children: React.ReactNode }) {
  const [activeVaultId, setActiveVaultId] = useState<string | null>(null);
  const [activeVaultName, setActiveVaultName] = useState<string | null>(null);
  const [activeVaultAccountTier, setActiveVaultAccountTier] = useState<AccountTier | null>(null);
  const [activeVaultStatus, setActiveVaultStatus] = useState<VaultStatus | null>(null);
  const [activeVaultUserRole, setActiveVaultUserRole] = useState<VaultRole | null>(null);

  function setActiveVault(id: string | null, name: string | null, tier?: AccountTier | null, status?: VaultStatus | null, userRole?: VaultRole | null) {
    setActiveVaultId(id);
    setActiveVaultName(name);
    setActiveVaultAccountTier(tier ?? null);
    setActiveVaultStatus(status ?? null);
    setActiveVaultUserRole(userRole ?? null);
  }

  return (
    <VaultContext.Provider value={{ activeVaultId, activeVaultName, activeVaultAccountTier, activeVaultStatus, activeVaultUserRole, setActiveVault }}>
      {children}
    </VaultContext.Provider>
  );
}

export function useVault() {
  return useContext(VaultContext);
}
